import { useQuery } from "urql"

import { GetAssociatedLocationsByCompanyDocument } from "@/graphql/codegen/graphql"
import type { Location } from "@/graphql/codegen/graphql"

interface UseGetLocationListByCompanyReturn {
  locations: Pick<Location, "locationId" | "name">[]
  isFetching: boolean
  refetchAssociatedLocations: () => void
}

export const useGetLocationListByCompany = (companyId: string): UseGetLocationListByCompanyReturn => {
  const [{ data, fetching }, reexecuteQuery] = useQuery({
    query: GetAssociatedLocationsByCompanyDocument,
    variables: { companyId },
  })

  const locations = data?.companyProductAssociation?.getLocationListByCompany ?? []

  const refetchAssociatedLocations = () => reexecuteQuery({ requestPolicy: "network-only" })

  return { locations, isFetching: fetching, refetchAssociatedLocations }
}
